module.exports = __webpack_public_path__ + "img/Menu.81580ddb.svg";